export default __webpack_public_path__ + "static/media/team-viewer-grey-icon.214aa393.png";